import { useTreatmentType } from '@/services/healthClaim/useTreatmentType'
import { useEffect, useState } from 'react'
import { TreatmentTypeResponseType } from '@/services/healthClaim/useTreatmentType/type'
import { TreatmentTypeSelectHookProps, TreatmentTypeSelectHookType } from './type'
import { useRecoilValue } from 'recoil'
import healthClaimFormAtom from '@/recoil/healthClaimForm'

export function TreatmentTypeSelectHook({
  policyNumber,
}: TreatmentTypeSelectHookProps): TreatmentTypeSelectHookType {
  const healthClaim = useRecoilValue(healthClaimFormAtom)
  const [data, setData] = useState<TreatmentTypeResponseType[]>()
  const treatmentType = useTreatmentType({ policyNumber })

  useEffect(() => {
    if (treatmentType.data) {
      setData(treatmentType.data)
    }
  }, [treatmentType.data])

  useEffect(() => {
    if (healthClaim.data?.treatment) {
      treatmentType.refetch()
    }
  }, [healthClaim.data?.treatment])

  return { data, isLoading: treatmentType.isLoading }
}
